// extracted by css-extract-rspack-plugin
export default {"passCodeWrapper":"s45OH5UW","passCodeInput":"aO8mpf1F"};